const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/franchises/$id/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { getFranchise } from "@/queries/franchise";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/franchises/$id/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient,
      country
    } = context;
    await queryClient.prefetchInfiniteQuery({
      queryKey: ["franchise", {
        id,
        country,
        limit: 20
      }],
      queryFn: ({
        pageParam
      }) => getFranchise({
        slug: id,
        limit: 20,
        page: pageParam as number,
        country: country ?? "US"
      }).catch(() => null),
      initialPageParam: 1,
      getNextPageParam: (lastPage: FranchiseResponse | null, allPages: (FranchiseResponse | null)[]) => {
        if (!lastPage) return undefined;
        if (lastPage.page * lastPage.limit >= lastPage.total) {
          return undefined;
        }
        return allPages.length + 1;
      }
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient),
      country
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("franchises.meta.notFoundTitle"),
          description: i18n.t("franchises.meta.notFoundDescription")
        }]
      };
    }
    const franchisePages = getFetchedQuery<{
      pages: FranchiseResponse[];
    }>(queryClient, ctx.loaderData.dehydratedState, ["franchise", {
      id: params.id,
      country: ctx.loaderData.country,
      limit: 20
    }]);
    const franchise = franchisePages?.pages[0];
    if (!franchise) {
      return {
        meta: [{
          title: i18n.t("franchises.meta.notFoundTitle"),
          description: i18n.t("franchises.meta.notFoundDescription")
        }]
      };
    }
    return {
      meta: [{
        title: i18n.t("franchises.meta.title", {
          name: franchise.name
        })
      }, {
        name: "description",
        content: i18n.t("franchises.meta.description", {
          name: franchise.name
        })
      }, {
        name: "og:title",
        content: i18n.t("franchises.meta.title", {
          name: franchise.name
        })
      }, {
        name: "og:description",
        content: i18n.t("franchises.meta.description", {
          name: franchise.name
        })
      }, {
        property: "twitter:title",
        content: i18n.t("franchises.meta.title", {
          name: franchise.name
        })
      }, {
        property: "twitter:description",
        content: i18n.t("franchises.meta.description", {
          name: franchise.name
        })
      }]
    };
  }
});